import React from "react";
import "./Annotation.css";
import KeytermPopover from "../KeytermPopover/KeytermPopover";


const Annotation = ({ timeline, createElement, annotationPaneRef }) => {

  const formatTooltip = (str) => {
    let parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    const parent = doc.body.getElementsByTagName('p')
    const elements = parent[0].childNodes
    const formattedElements = Array.from(elements).map((element, index) => {
      if (element.localName === "a") {
        return [<KeytermPopover
          title={element.innerHTML}
          description={element.title}
          annotationPaneRef={annotationPaneRef}
          key={index}
        />]
      }
      else {
        return element
      }
    })
    return formattedElements
  }

  return (
    <div className="annotation-paragraph-container">
      <p>{Array.from(formatTooltip(timeline.frames[0].text)).map((element, index) => (Array.isArray(element) ? element :
        element.nodeName === "#text" ?
          <span key={index}>{element.textContent}</span>
          :
          element.localName === "img" ?
            createElement(element.localName, { "src": element.src, "className": element.className, "width": element.width, "key": index, "alt": element.alt })
            :
            element.localName === "em" ?
              <em key={index}>{element.textContent}</em>
              :
              createElement(element.localName, { "key": index })
      ))}
      </p>
    </div>
  )
}

export default Annotation